export const AOL_TOOLTIP_TEXT = {
  primary: 'This is the FromCounsel knowledge area that you wish to be your \'home area of law\' on FromCounsel. This selection will determine your: default homepage news feed; default news archive; and priority ordering of Q&A tiles. Note that you require an FromCounsel subscription in order to set an area of law as your home.',
  practising: 'This is the primary area of law within which you practice'
}

export const NO_ACCESS_MESSAGE = 'You do not have access to this as part of your FromCounsel subscription.'
